<template>
	<v-dialog scrollable persistent v-model="showDialog" max-width="820">
		<v-card>
			<v-card-title>Report Preview</v-card-title>
			<v-container
				fluid
				class="flexContainerItem pb-0"
				style="overflow: hidden"
			>
				<report-preview :report="report" />
			</v-container>
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import ReportPreview from './ReportPreview.vue';
import { mapGetters } from 'vuex';
import { ReportPreviewActions } from '../../../../../store/actions';
import { ReportPreviewGetters } from '../../../../../store/getters';

export default {
	name: 'ReportPreviewModal',
	props: { reportId: String, showDialog: Boolean },
	components: { ReportPreview },
	computed: {
		...mapGetters({
			report: [ReportPreviewGetters.REPORT],
		}),
	},
	mounted() {
		this.$store.dispatch(
			ReportPreviewActions.LOAD_REPORT_BY_ID,
			this.reportId
		);
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
	},
};
</script>
